import { render, staticRenderFns } from "./WidgetTextSize.vue?vue&type=template&id=34436a88&"
import script from "./WidgetTextSize.vue?vue&type=script&lang=js&"
export * from "./WidgetTextSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetTextSize.vue"
export default component.exports